<template>
  <div class="main">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">申请</div>
      <div class="nav-right">
        <img class="none" />
      </div>
    </div>
    <div class="info2">
       <div class="info-item ub">
            <span class="key">签名</span>
            <textarea contenteditable="true" v-model="sign_self" placeholder="编辑个签，展现我的独有特点！" class="sign-txt"></textarea>
        </div>
    </div>
    <div class="ub ub-ac" style="padding: 0 .8em;">
      <div class="ub ub-ac ub-pc submit-btn" @click="save()" >下一步</div>
    </div>
   
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      "sign_self":""
    };
  },
  mounted() {
   this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page() {
      var uid = this.$store.state.uid;
      var self = this;
      this.$loading("加载...");
      setTimeout(() => {
        self.$loading.close();
      }, 5000);
      self.get({
        url: "/App/Get_Play_Data_One/?uid=" + uid,
        success: function (data) {
          self.$loading.close();
          console.log(JSON.stringify(data));
          if( data.sign_self){
            self.sign_self = data.sign_self;
          }
          
        },
      });
    },

    save(){
      if(this.sign_self==""){
        this.$toast.top("签名不能为空哦");
        return false;
      } 
      if(this.sign_self.length>300){
        this.$toast.top("签名只能输入150个汉字哦~");
        return false;
      } 

      var uid = this.$store.state.uid;

     var self = this;
     var data_send={
       "sign_self":this.sign_self
     };
     var strsend = JSON.stringify(data_send);

      this.post({
          url: "/App/Update_User_Play",
          data: { "uid": uid, "data": strsend },
          success: function (serve_data) {
           console.log(JSON.stringify(serve_data));
            if(serve_data.state=="1"){
              self.$router.push({ "name": "play_list"});
            }
          },
        });
     
    }
  },
};
</script>

<style scoped>
.main{
   position: absolute;
   background-color: #fff;
   width: 100%;
   bottom: 0;
   top:0;
 }

.info2{
  padding: .8em;
  border-bottom: .5em solid #f5f5f5;
}
  .key{
      padding: .3em 0 0 0;
      width: 3em;
      font-size: .95em;
      font-weight: bold;
  }
 .sign-txt {
  margin: 0.4em 0 0 .8em;
  height: 6em;
  width: 100%;
  outline: none;
  border-color: rgb(169, 215, 247);
  background-color: #fff;
  border-radius: 0.3em;
  padding: 0.3em 0 .3em .3em;
  color: #333;
  font-size: .9em;
  resize: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.sign-txt:focus {
  border-color: rgb(33, 164, 252);
}
.btn-block{
    background-color: #fff;
    padding: .4em .8em 1.5em .8em;
  }
  .submit-btn {
  width: 100%;
  height: 2.3em;
  line-height: 2.3em;
  border-radius: 1.15em;
  background-color: #fc568c;
  margin-top: .5em;
  color: #fff0f4;
}
</style>